import { render, staticRenderFns } from "./PriceField.vue?vue&type=template&id=96c8fa74&"
import script from "./PriceField.vue?vue&type=script&lang=ts&"
export * from "./PriceField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports